import { useSyncExternalStore } from 'react'

function subscribe(callback: () => void) {
  window.addEventListener('online', callback)
  window.addEventListener('offline', callback)
  return () => {
    window.removeEventListener('online', callback)
    window.removeEventListener('offline', callback)
  }
}

export function useOnline(): boolean {
  return useSyncExternalStore(subscribe, () => navigator.onLine, () => true)
}

/** Slim banner shown while the browser reports no connectivity.
 * Rendered inside the sticky header so it pins together with the nav. */
export default function OfflineBanner() {
  const online = useOnline()
  if (online) return null
  return (
    <div
      role="status"
      className="bg-ink text-white text-center text-sm font-bold py-1.5 px-4"
      data-testid="offline-banner"
    >
      You're offline — viewing cached data. Simulations and sharing need a connection.
    </div>
  )
}
